import {
  liveStatsVuexGetters,
} from '@ahaslides-product/frontend-toolkit'
import config from '@/config'
import { isFeatureEnabled, isPresentationCreatedAfterTurnOnFlag } from '../feature-toggles.module'

const isLiveProxyNotEnabledOnLocal = config.env === 'local' && !config.isLiveProxyUrlSet

const _getters = {
  ...liveStatsVuexGetters,
  canUseKvSyncLiveStats: (_, __, ___, rootGetters) => {
    return isPresentationCreatedAfterTurnOnFlag(rootGetters, 'kv-sync-emqx-for-live-stats') &&
      isFeatureEnabled(rootGetters, 'kv-sync-emqx-for-live-stats')
  },
  canSubmitReactionEmqx: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'audience-reaction-emqx')
  },
  canSubscribeReactionEmqx: (_, getters, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'audience-reaction-emqx') &&
      isFeatureEnabled(rootGetters, 'presenter-reaction-emqx') &&
      isPresentationCreatedAfterTurnOnFlag(rootGetters, 'audience-reaction-emqx') &&
      getters.canUseKvSyncLiveStats
  },
  canUseLiveStatsForQuiz: (_, __, ___, rootGetters) => {
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'livestats-quiz-submission')
  },
  canUsePollLiveProxy: (_, __, ___, rootGetters) => {
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-poll')
  },
  canUsePollLiveApi: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'audience-poll-emqx')
  },
}

export default _getters
